module.exports = "<div class=\"ImageMediaCategoriesCon\" fxLayout=\"column\">\n  <app-mediacommon [bookObj]=\"bookObj\" (onSelectGimage)=\"onChnageGimage($event)\" style=\"height:100%\"></app-mediacommon>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/mediacategories/mediacategories.component.html
// module id = ./src/app/bookShared/bookeditoption/bookEditOptionPopups/mediacategories/mediacategories.component.html
// module chunks = main